// oxlint-disable-next-line no-warning-comments
// HOTSPOT: Logo geometry duplicated in bin/generate-icons.ts.
import type { FC } from "react";
import React from "react";

const TRACKS = [0, 1, 2] as const;

const CENTER = 1;

const TRACK_START = 2;

const TRACK_GAP = 7.25;

const CELL_SIZE = 5.5;

const CELL_BORDER_RADIUS = 1.2;

interface LogoProps {
  readonly className?: string;
}

export const Logo: FC<LogoProps> = ({ className }) => (
  <svg
    aria-hidden
    className={className}
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {TRACKS.flatMap(row =>
      TRACKS.filter(col => !(col === CENTER && row === CENTER)).map(col => (
        <rect
          height={CELL_SIZE}
          key={`${col}-${row}`}
          rx={CELL_BORDER_RADIUS}
          width={CELL_SIZE}
          x={TRACK_START + col * TRACK_GAP}
          y={TRACK_START + row * TRACK_GAP}
        />
      )),
    )}
  </svg>
);
